import React, { useContext } from "react";
import { motion } from "framer-motion";
import { MdCircle } from "react-icons/md";
import { CursorContext } from "../context/CursorContext";
import { items } from "../Data";

const Skill = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);

  return (
    <motion.section
      initial={{ opacity: 0, y: 100 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: false, amount: 0.2 }}
      className="section h-screen snap-start flex items-center justify-center overflow-hidden pt-36  pb-24"
      id="skill"
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseLeaveHandler}
    >
      <div className="w-full max-w-5xl test-secondary mx-auto px-4">
        {items.map(({ tech_color, tech_name }, index) => {
          const isEven = index % 2 === 0;
          const screenWidth = window.innerWidth; // 🧩 Determine animation offset based on screen size
          let offset = 150; // 🧩 default
          if (screenWidth > 1280)
            offset = 800; // 🧩 large screen (e.g. 2K, 4K)
          else if (screenWidth > 768)
            offset = 500; // 🧩 medium screen
          else if (screenWidth > 468)
            offset = 300; // 🧩 small screen (mobile)
          else offset = 150;
          const direction = isEven ? offset : -offset; // 🧩 alternate row animation direction more distance = longer/faster slide
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: direction }}
              whileInView={{ opacity: 0.8, x: 0 }}
              viewport={{ once: false, amount: 0.2 }} // 🧩 triggers animation every time it enters view
              transition={{ duration: 1.5, ease: "easeInOut" }} // 🧩 animation speed and feel (2.5s makes it slower and smooth)
              className="mb-10 flex items-center justify-center gap-4 text-slate-600"
            >
              {Array.from({ length: 15 }, (_, idx) => (
                <React.Fragment key={idx}>
                  <span
                    className="text-5xl font-extrabold uppercase tracking-tighter font-mono"
                    style={{
                      color:
                        idx === 7 || idx === 4 || idx === 10
                          ? tech_color
                          : "inherit", // 🧩 highlights the center word
                    }}
                  >
                    {tech_name}
                  </span>
                  <span className="text-xl">
                    <MdCircle /> {/* 🧩 dot between each word */}
                  </span>
                </React.Fragment>
              ))}
            </motion.div>
          );
        })}
      </div>
    </motion.section>
  );
};

export default Skill;
